/* eslint-disable @angular-eslint/component-selector */
/* eslint-disable @angular-eslint/no-empty-lifecycle-method */
import { Component, effect, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '@api';
import { HelperService } from '@core';
import { CountdownService } from '@core/Services/countdown.service';
import { GTMService } from '@core/Services/gtm.service';
import { ListenerService } from '@core/Services/listener.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
})
export class MenuComponent implements OnInit {
  isSidebarOpen?: boolean = false;
  current: any;
  isLogin = false;
  timer: any;
  @Output() _toggleMenu = new EventEmitter();
  active: any = 'home';

  menu: any;

  isEventStart: boolean = true;

  position_mobile: any = '';

  isCollapsedMenu1: boolean = false;
  isCollapsedMenuOfflineEvent: boolean = false;
  isCollapsedMenuInfo: boolean = false;

  // isPromo = environment.isPromo;
  // isSurvey = environment.isSurvey;

  constructor(
    public helper: HelperService,
    public auth: AuthService,
    private countdown: CountdownService,
    private listener: ListenerService,
    private router: Router,
    private gtmService: GTMService,
  ) {
    effect(() => {
      this.isSidebarOpen = this.helper.toggleMenu();

      if (this.auth.users()) {
        this.isLogin = true;
      }

      if (this.listener.currentSection()) {
        this.current = this.listener.currentSection();

        // console.log(this.current);
      }

      if (false) {
        this.menu = 1;
      } else {
        if (this.countdown.time().timer <= 0) {
          this.isEventStart = true;
          this.menu = 1;
        } else {
          this.menu = 0;
          this.isEventStart = false;
        }
      }
    });
  }

  ngOnInit() {}

  toggleMenu() {
    this.helper.toggleMenu.update((v) => (v = !this.isSidebarOpen));
  }
  toMenu(name: any) {
    this.toggleMenu();
    this.current = name;
    this.listener.sidebarSelected.update((v) => (v = name));
    this.router.navigateByUrl(name)
  }

  openExternalLink(link: any) {
    window.open(link, '_self');
  }

  logout() {
    this.gtmService.gtmLogout();
    this.auth.logout();
  }

  setACtive(name: any) {
    this.active = name;
    let url = this.router.url;
    if (url != '/home') return;
    this._toggleMenu.emit(name);
  }

  getInitial() {
    if (this.auth.users()!.name) {
      let member_name = this.auth.users()!.name.split(' ');
      if (member_name.length > 1) {
        return (
          member_name[0].charAt(0).toUpperCase() +
          member_name[1].charAt(0).toUpperCase()
        );
      } else {
        return member_name[0].charAt(0).toUpperCase();
      }
    } else {
      return '';
    }
  }

  analyticClickAction(tag: any) {
    this.helper.sendAnalytic('click', tag).subscribe((res) => {});
  }

  toSurvey() {
    this.toggleMenu();
    localStorage.setItem('backUrlKPR', this.router.url);
    this.router.navigateByUrl('/survey');
  }

  toSurveyOffline() {
    this.toggleMenu()
    localStorage.setItem('backUrlKPR', this.router.url);
    this.router.navigateByUrl('/survey-offline');
  }
}
